export enum ModalWidth {
    XSmall = '350px',
    Small = '600px',
    Medium = '850px',
    Large = '1000px',
    MobileFullWidth = '95vw'
}